import Image from '@tiptap/extension-image';
import type { MarkdownNodeSpec } from 'tiptap-markdown';

/**
 * Block-level image with a block-aware markdown serializer. The stock
 * tiptap-markdown 0.8 pipeline serializes image through prosemirror-markdown's
 * INLINE image spec, which never closes the block, so the next paragraph gets
 * glued onto the figure line (`![alt](src)Next paragraph`), breaking the
 * dialect's standalone-figure contract (`![alt](src "caption")` on its own
 * line becomes `figure.post-figure`). This extension writes the image and then
 * closes the block; the `title` attr carries the figure caption.
 */
export const FigureImage = Image.extend({
  addStorage() {
    const markdown: MarkdownNodeSpec = {
      serialize(state, node) {
        const alt = String(node.attrs.alt ?? '');
        const src = String(node.attrs.src ?? '').replace(/[()]/g, '\\$&');
        const title = node.attrs.title ? ` "${String(node.attrs.title).replace(/"/g, '\\"')}"` : '';
        state.write(`![${state.esc(alt)}](${src}${title})`);
        state.closeBlock(node);
      },
      parse: {},
    };
    return { markdown };
  },
});

export default FigureImage;
